/* eslint-env es6 */
import {ts as utilTs} from './util.es6';
let PERFMARKS = {};
export function ts () {
    if ('performance' in window) {
        if ('now' in window.performance) {
            return Math.round(window.performance.now());
        } else if ('webkitNow' in window.performance) {
            return Math.round(window.performance.webkitNow());
        }
    }
    return utilTs();
}
export function mark (name) {
    PERFMARKS[name] = ts();
}
export function measure (name) {
    var time = ts() - PERFMARKS[name];
    clear(name);
    return time;
}
export function clear (name) {
    delete PERFMARKS[name];
}



// WEBPACK FOOTER //
// ./app/src/lib/perf.es6